import ControllerBringSymbolsToFront from './ControllerBringSymbolsToFront';

export default class ControllerStickyReels {
  constructor({ containerReels, controllerReels }) {
    this.ControllerReels = controllerReels;
    this.ControllerBringSymbols = new ControllerBringSymbolsToFront(containerReels);
  }

  onStart() {
    this.checkReelsForExclude();
    this.ControllerReels.excludedReels.forEach(reelIndex => {
      this.tryToActivateSymbol(reelIndex);
    })
  }

  tryToActivateSymbol(reelIndex) {
    const symbol = this.ControllerReels.reels[reelIndex].symbols[this.ControllerReels.topSimbolsCount];
    if (!symbol.id) return;

    this.ControllerBringSymbols.bringToFront(symbol);
    // symbol.scatterStop();
  }

  checkReelsForExclude() {
    const excluded = [];

    for (let i = 0; i < this.ControllerReels.reels.length; i++) {
      const symbol = this.ControllerReels.reels[i].symbols[this.ControllerReels.topSimbolsCount];
      if (!symbol.id) continue;
      excluded.push(i);
    }

    this.ControllerReels.excludedReels = excluded;
  }

  reset() {
    this.ControllerReels.excludedReels = [];
    this.ControllerBringSymbols.bringAllBack();
  }
}
